import type { ReactElement } from 'react';
import { mealTypeIcon } from '../../api/types.js';
import type { MealType, Recipe } from '../../api/types.js';

interface RecipeCardProps {
  recipe: Recipe;
  onClick: () => void;
}

export function RecipeCard({ recipe, onClick }: RecipeCardProps): ReactElement {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full flex-col items-start gap-1 rounded-xl border p-3 text-left shadow-sm"
      style={{
        background: 'var(--bg-surface)',
        borderColor: 'var(--border)',
        color: 'var(--text-main)',
        minHeight: 80,
      }}
      data-testid={`recipe-card-${recipe.id}`}
    >
      <div className="flex items-center gap-2 text-base font-semibold">
        <span aria-hidden="true">{mealTypeIcon(recipe.meal_type as MealType)}</span>
        <span>{recipe.title}</span>
      </div>
      <div className="text-xs" style={{ color: 'var(--text-muted)' }}>
        🕒 {recipe.prep_time_minutes} Min · 👥 {recipe.portions} Port. ·{' '}
        {recipe.per_portion.kcal} kcal
      </div>
      <div className="text-xs" style={{ color: 'var(--text-muted)' }}>
        P: {recipe.per_portion.protein_g}g · C: {recipe.per_portion.carbs_g}g · F:{' '}
        {recipe.per_portion.fat_g}g
      </div>
      {recipe.tags.length > 0 ? (
        <div className="mt-1 flex flex-wrap gap-1">
          {recipe.tags.map((t) => (
            <span
              key={t}
              className="rounded-full border px-2 py-0.5 text-xs"
              style={{ borderColor: 'var(--border)', color: 'var(--text-muted)' }}
            >
              {t}
            </span>
          ))}
        </div>
      ) : null}
    </button>
  );
}